const styles = theme => ({
  errorList: {
    listStyle: 'none',
    width: '100%',
    margin: 0,
    padding: 0
  },
  error: {
    padding: theme.spacing.unit * 1.5,
    borderRadius: '4px',
    backgroundColor: 'rgba(242,45,18,0.08)',
    marginBottom: theme.spacing.unit * 1,
    alignItems: 'center',
    display: 'flex'
  },
  errorIcon: {
    color: '#F22D12',
    marginRight: theme.spacing.unit * 1.5
  },
  errorText: {
    color: '#F22D12 !important'
  },
  footerContent: {
    marginTop: [theme.spacing.unit * 3, '!important']
  },
  subHeading: {
    paddingTop: theme.spacing.unit * 3.125,
    paddingBottom: theme.spacing.unit * 3.75
  }
});

export default styles;
